import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../../app.component';
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { OrderPipe } from 'ngx-order-pipe';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-nec-ongoing-projects',
    templateUrl: './nec-ongoing-projects.component.html',
    styleUrls: ['./nec-ongoing-projects.component.scss']
})
/** nec-ongoing-projects component*/
export class NecOngoingProjectsComponent {
    /** nec-ongoing-projects ctor */
  necOngoingProjects: any='';
  route: any;
    MenuList: any;
    title: any;
    showhide: boolean;
    fileUrl: any;
  itemsPerPage: number;
  Search: any;
  paginationPageNumber: number;
  necOngoingProjectsCount: any;
  currentDate: any = new Date();
  modeltitle: any;
  content: any;
  image: any;
  multipleEntry: boolean = false;
  imgUrl: any;
    url: any;
  necSpinner: boolean;
  constructor(private spinner: NgxSpinnerService,private appComponent: AppComponent, private http: HttpClient, private router: Router, private datePipe: DatePipe, private orderpipe: OrderPipe) {
    this.imgUrl = window["orginalImgUrl"];
    this.url = window['NECOngoingProjects'];
    var str = this.router.url;
    this.route = str.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
  }
  ngOnInit() {
    this.spinner.show();
    this.paginationPageNumber = 1;
    this.itemsPerPage = 10;
    this.getMenuName();
    this.getNECOngoingProjects();
    
  }

  search() {
    this.paginationPageNumber = 1;
  }

  getMenuName() {
    this.http.get(this.appComponent.APIUrl + 'MenuMaster/', {
    }).subscribe((data: any) => {
      this.MenuList = data.menuMasterDTO.filter(x => x.link == this.route);
      this.title = this.MenuList[0].title;
      this.multipleEntry = this.MenuList[0].multipleEntry;
    });
  }

  getNECOngoingProjects() {
    if (this.url != '') {
      this.necSpinner = true;
      this.http.get(this.url, {
      }).subscribe((data: any) => {
        this.necSpinner = false;
        this.necOngoingProjects = data;
        this.necOngoingProjectsCount = this.necOngoingProjects.length;
      });
    }
  }

  itemPerPagePagination(event: any) {
    this.itemsPerPage = event.target.value;
  }
}
